<template>
  <div id="review-report-dialog">
    <ipub-model :title="'Review Rating'"
                width="400px"
                :visable="isVisable"
                :showFooter="false"
                @confirm="confirm"
                @cancel="cancel">
      <div class="mar-b-20 ipub-p2">
        <div class="fw-bd mar-b-10">Rate<span class="key-color">*</span></div>
        <ipub-radio-group v-model="params.rating">
          <ipub-radio key="EXCELLENT"
                      value="EXCELLENT">
            <div style="margin-right:22px">Excellent</div>
          </ipub-radio>
          <ipub-radio key="GOOD"
                      value="GOOD">
            <div style="margin-right:22px">Good</div>
          </ipub-radio>
          <ipub-radio key="AVERAGE"
                      value="AVERAGE">
            <div style="margin-right:22px">Average</div>
          </ipub-radio>
          <ipub-radio key="POOR"
                      value="POOR">
            <div style="margin-right:22px">Poor</div>
          </ipub-radio>
        </ipub-radio-group>
      </div>
      <div class="mar-b-30 ipub-p2">
        <div class="fw-bd mar-b-10">Discount Voucher
          <ipub-tooltip placement="right">
            <div slot="title">After selecting the voucher, the system will automatically send the discount code to the reviewer by email.</div>
            <ipub-icon type="iconInfo" />
          </ipub-tooltip>
        </div>
        <ipub-radio-group v-model="params.discountId"
                          v-if="params.discountFlag?true:false">
          <ipub-radio v-for="item in discountVoucherList"
                      style="margin-left:0;margin-right:20px"
                      :key="item.id"
                      :value="item.id">
            <div style="margin-right:22px">${{item.discount}}</div>
          </ipub-radio>
        </ipub-radio-group>
        <div v-else>
          $ {{params.discount || '- -'}}
        </div>
      </div>
      <div class="ipub-p2">
        <ipub-button type="primary"
                     plain
                     style="min-width:155px"
                     @click="cancel">
          Cancel
        </ipub-button>
        <ipub-button type="primary"
                     :disabled="!params.rating"
                     style="margin-left:16px;min-width:155px"
                     @click="confirm">
          Confirm
        </ipub-button>
      </div>
    </ipub-model>
  </div>
</template>

<script>

import { minvitedReviewer } from '@/api/reviewer'
import { discountJournalId } from '@/api/discount'

export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Object,
      default () {
        return {}
      },
    },
  },
  data () {
    return {
      params: {},
      discountVoucherList: []
    }
  },
  computed: {

  },
  watch: {
    isVisable (val) {
      if (val) {
        this.params = JSON.parse(JSON.stringify(this.inputData))
        this.getData()
      }
    }
  },
  methods: {
    async getData () {
      this.discountVoucherList = await discountJournalId.query(this.inputData.__journalId)
    },
    async confirm () {
      // console.log(this.params, '参数', this.inputData)
      if (!this.params.rating) {
        this.$message.success({
          title: 'Error',
          content: 'Rating cannot be empty!'
        })
        return
      }
      let data = {
        version: this.inputData.version,
        rating: this.params.rating,
        discountId: this.params.discountId
      }
      await minvitedReviewer.rating(this.inputData.id, data)
      this.$emit('confirm')
    },
    cancel () {
      this.$emit('cancel')
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
